export default class Fleet {
    constructor(
        id,
        name,
        totalDevices,
        unallocatedDevices,
        allocatedDevices
    ) {
        this.id = id
        this.name = name
        this.totalDevices = totalDevices
        this.unallocatedDevices = unallocatedDevices
        this.allocatedDevices = allocatedDevices
    }
}
